import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "../../../utils/toast";
import AddChart from "./AddChart";
import AddDashboardModal from "./AddDashboardModal";
import {
  fetchDashboardNames,
  fetchWorkflows,
} from "../../../service/UserDashboard.js";
import Joyride from "react-joyride";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext.js";
import translations from "../../common/Translations.js";
import CommonButton from "../../common/CommonButton.js";
import PowerBIDashboard from "../powerbi/PowerBiDashboard.jsx";
import ReactSelector from "../../common/CommonReactSelector.js";
import { components } from 'react-select';
import { Button } from "../../common/Button.js";
import { Spinner } from "../../../Spinner.js";
import { getPermissionByScreenCode } from "../../../utils/permissions.js";
import { Activity, BarChart3, LayoutDashboard, User } from "lucide-react";

const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};
const DASHBOARDS = {
  USER: "user",
  ACTIVITY: "activity",
  POWERBI: "powerbi",
};

const ActivityDashboard = () => {
  const dashboardPerm = getPermissionByScreenCode("ACTIVITY_DASHBOARD");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState("");
  const [selectedWorkflowId, setSelectedWorkflowId] = useState("");
  const [dashboardName, setDashboardName] = useState("");
  const [selectedrole, setSelectedRole] = useState("");
  const { selectedOrgId, langMode, runTour, activityDash, userType, projectId } =
    useContext(AppContext);
  const [dashboardNames, setDashboardNames] = useState([]);
  const [dashboardNameInput, setDashboardNameInput] = useState("");
  const [dashboardActions, setDashboardActions] = useState(null);
  const { theme } = useContext(AppContext);
  const [roleInput, setRoleInput] = useState("");
  const [data, setData] = useState([]);
  const [activeDashboard, setActiveDashboard] = useState(DASHBOARDS.ACTIVITY);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const GoExport = () => {
    Cookies.set("viewMode", "dashboard");
    navigate("/pdf-generator");
  };
  const idForParam = userType === "super_admin" ? selectedOrgId : null;
  const dashboardOptions = Array.isArray(dashboardNames) && dashboardNames.length > 0
    ? dashboardNames.map((dashboard) => ({
      value: dashboard?.activityDashboardId, 
      label: dashboard?.dashboardName,     
      role: dashboard?.role,            
    }))
    : [];

  const handleDashboardNameChange = (selectedOption) => {
    if (selectedOption) {
      setDashboardNameInput(selectedOption.value);
      setRoleInput(selectedOption.role);
    } else {
      setDashboardNameInput("");
      setRoleInput("");
    }
  };

  const selectedDashboardOption = dashboardOptions.find(
    (option) => option.value === dashboardNameInput
  );

  const handleFetchDashboardNames = () => {
    if (userType === "super_admin") {
      if (selectedOrgId) {
        fetchDashboardNames(projectId, Cookies.get("accessToken"))
          .then((dashboardNames) => {
            setDashboardNames(dashboardNames);
          })
          .catch(() => {
            setDashboardNames([]);
          });
      }
    } else {
      fetchDashboardNames(projectId, Cookies.get("accessToken"))
        .then((dashboardNames) => {
          setDashboardNames(dashboardNames);
        })
        .catch(() => {
          setDashboardNames([]);
        });
    }
  };

  useEffect(() => {
    handleFetchDashboardNames();
  }, [projectId]); 

  const fetchActivityNames = async () => {
    try {
      if (projectId) {
        const workflows = await fetchWorkflows(
          projectId,
          Cookies.get("accessToken")
        );
        setData(workflows);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching workflows:", error);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const showModal = () => {
    if (
      !dashboardPerm?.canCreate &&
      userType !== "super_admin"
    ) {
      toast.error(
        " You don't have the necessary permissions to view this page."
      );
      return;
    }
    if (userType === "super_admin") {
      if (selectedOrgId) {
        setIsModalOpen(true);
        fetchActivityNames();
      } else {
        toast.warning(translations[langMode].plzselectorg);
      }
    } else {
      setIsModalOpen(true);
      fetchActivityNames();
    }
  };
  const gouserDashbord = () => {
    navigate("/dashboard");
  };

  const switchDashboard = (dashboard) => {
    setLoading(true);
    setTimeout(() => {
      setActiveDashboard(dashboard);
      setLoading(false);
    }, 300);
  };
  
useEffect(() => {
  setLoading(true);

  const timer = setTimeout(() => {
    setLoading(false);
  }, 1000);

  return () => clearTimeout(timer);
}, []);

  const userPrivileges = JSON.parse(Cookies.get("userPrivileges") || "[]");


  return (
    <div className="w-full">
    {loading && <Spinner />}
      <Joyride
        steps={activityDash}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        scrollToFirstStep
        styles={{
          options: {
            arrowColor: "#fff",
            zIndex: 10000,
            overlayColor: "rgba(0, 0, 0, 0.5)",
            primaryColor: "#4C3BCF",
            textColor: "#333",
            zIndex: 1000,
          },
          tooltip: {
            borderRadius: "10px",
          },
          buttonSkip: {
            color: "#4C3BCF",
          },
          buttonNext: {
            backgroundColor: "#4C3BCF",
          },
          buttonBack: {
            color: "#4C3BCF",
          },
        }}
      />
      <div
        className={`w-full ${theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : "w-full"
          } `}
      >
        <h4
          className={`page-title inline-flex items-center gap-2 ${theme === "dark"
            ? "dark-mode "
            : theme === "high-contrast"
              ? "high-contrast  "
              : ""
            }`}
        >
          {translations[langMode].dashboardManagement}
        </h4>
        <div className="mt-4 flex flex-wrap items-center justify-between gap-3 sm:gap-4">
          <div className="flex min-w-0 items-center">
            <div
                className="flex w-full max-w-full flex-wrap items-center gap-2 rounded-[10px] bg-white p-1 shadow-[0_1px_2px_rgba(0,0,0,0.04)] dark:bg-gray-800 sm:w-auto sm:gap-3"
              role="group"
            >
              <Button
                onClick={gouserDashbord}
                isActive={activeDashboard === DASHBOARDS.USER}
                aria-label="User Dashboard"
                className="h-10 min-h-[40px] rounded-[10px] px-3 py-2 text-xs sm:px-4 sm:text-sm"
              >
                <User className="h-4 w-4 hidden sm:block" />
                {translations[langMode].userdashboard}
              </Button>
              <Button
                onClick={() => switchDashboard(DASHBOARDS.ACTIVITY)}
                isActive={activeDashboard === DASHBOARDS.ACTIVITY}
                aria-label="Activity Dashboard"
                className="h-10 min-h-[40px] rounded-[10px] px-3 py-2 text-xs sm:px-4 sm:text-sm"
              >
                <Activity className="h-4 w-4 hidden sm:block" />
                {translations[langMode].activitydashboard}
              </Button>
             <Button
                onClick={() => switchDashboard(DASHBOARDS.POWERBI)}
                isActive={activeDashboard === DASHBOARDS.POWERBI}
                aria-label="PowerBi Dashboard"
                className="h-10 min-h-[40px] rounded-[10px] px-3 py-2 text-xs sm:px-4 sm:text-sm"
              >
                <BarChart3 className="h-4 w-4 hidden sm:block" />
                {translations[langMode].powerbidashboard}
              </Button>
            </div>
          </div>
                  {activeDashboard === DASHBOARDS.ACTIVITY && (
          <div className="flex gap-3 ml-auto sm:ml-0">
            <CommonButton colorIntent="primary"
              onClick={showModal}
              className={`createdashboard ${!dashboardPerm?.canCreate ? "cursor-not-allowed opacity-50" : ""}`}
              variant="primary"
              tooltipText={translations[langMode].addnewdashboardtooltip}
              tooltipPosition="left"
              disabled={!dashboardPerm?.canCreate}
            >
              <LayoutDashboard size={18} />{" "}
              {translations[langMode].addnewDashboard}
            </CommonButton>
          </div>
                  )}
        </div>
        {activeDashboard === DASHBOARDS.ACTIVITY && (
          <>
            <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
              <div className="dashboardname">
                <label
                  htmlFor="organizationId"
                  className={`block text-sm mb-2 font-medium text-gray-900 ${theme === "dark"
                    ? "dark-mode "
                    : theme === "high-contrast"
                      ? "high-contrast  "
                      : ""
                    }`}
                >
                  {translations[langMode].dashboardName}
                </label>
                <ReactSelector
                  components={Placeholder}
                  defaultValue={translations[langMode].selectDash}
                  id="dashboardName"
                  name="dashboardName"
                  options={dashboardOptions}
                  value={selectedDashboardOption}
                  onChange={handleDashboardNameChange}
                  placeholder={translations[langMode].selectDash}
                  height="36px"
                  menuPortalTarget={document.body}
                  forceLtr={langMode === "ar"}
                  className={`w-full max-w-xs ${theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                    }`}
                />
              </div>
              {dashboardActions && (
                <div className="flex items-center">{dashboardActions}</div>
              )}
            </div>
            {!dashboardNameInput && (
              <div
                className={`mt-6 flex flex-col items-center justify-center gap-3 rounded-xl border px-4 py-12 text-center ${theme === "dark"
                  ? "border-gray-700 bg-gray-800"
                  : theme === "high-contrast"
                    ? "border-yellow-400 bg-black"
                    : "border-gray-200 bg-gray-50"
                  }`}
              >
                <LayoutDashboard
                  className={`h-10 w-10 ${theme === "dark"
                    ? "text-gray-500"
                    : theme === "high-contrast"
                      ? "text-yellow-400"
                      : "text-gray-400"
                    }`}
                />
                <h2
                  className={`text-sm font-semibold text-gray-900 ${theme === "dark"
                    ? "dark-mode "
                    : theme === "high-contrast"
                      ? "high-contrast  "
                      : ""
                    }`}
                >
                  {translations[langMode].chartMessage}
                </h2>
              </div>
            )}
            {isModalOpen && (
              <AddDashboardModal
                onClose={handleCloseModal}
                organizations={organizations}
                setOrganizations={setOrganizations}
                selectedOrganizationId={selectedOrganizationId}
                setSelectedOrganizationId={setSelectedOrganizationId}
                selectedWorkflowId={selectedWorkflowId}
                setSelectedWorkflowId={setSelectedWorkflowId}
                dashboardName={dashboardName}
                setDashboardName={setDashboardName}
                selectedrole={selectedrole}
                setSelectedRole={setSelectedRole}
                selectedOrgId={selectedOrgId}
                data={data}
              />
            )}
            <AddChart
              selectedOrgId={selectedOrgId}
              dashboardNames={dashboardNames}
              setDashboardNames={setDashboardNames}
              dashboardNameInput={dashboardNameInput}
              setDashboardNameInput={setDashboardNameInput}
              roleInput={roleInput}
              dashboardPerm={dashboardPerm}
              setDashboardActions={setDashboardActions}
            />
          </>
        )}
        {
          activeDashboard === DASHBOARDS.POWERBI && (
            <PowerBIDashboard /> 
          )
        }
      </div>
    </div>
  );
};

export default ActivityDashboard;
